import { render, staticRenderFns } from "./caseBase.vue?vue&type=template&id=7f101e9c&scoped=true"
import script from "./caseBase.vue?vue&type=script&lang=js"
export * from "./caseBase.vue?vue&type=script&lang=js"
import style0 from "./caseBase.vue?vue&type=style&index=0&id=7f101e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f101e9c",
  null
  
)

export default component.exports